export default {
  get: function (allocations, selectedAllocations, isEditableRefId) {
    return {
      Id: '_',
      '*Name': {
        label: 'Category',
        width: 120,
        options: allocations,
        source: true,
        compose: allocationName,
        selectedOptions: selectedAllocations,
        trackBy: {
          optionTrackBy: 'Key',
          selectedOptionTrackBy: 'Id'
        },
        editable: true
      },
      AdditionalNo: {
        label: 'Ref ID',
        width: 90,
        editable: isEditableRefId,
        maxLength: 50
      },
      Percent: {
        label: 'Allocation Percent',
        width: 80,
        editable: true
      },
      Amount: {
        label: 'Allocation Amount',
        width: 80,
        f: 'data.Amount',
        validSum: {value: 0},
        editable: true
      }
    }
  }
}
function allocationName(params) {
  return params.data && params.data.Name ? params.data.Name : ' '
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/category-allocation-model.js